import { createRef, useState } from 'react';
import type { ThemeEdit } from '../../types/theme';
import ThemeDetail from './ThemeDetail';
import ThemeList from './ThemeList';

const Themes = () => {
    const [itemToEdit, setItemToEdit] = useState<ThemeEdit | null>(null);
    const wrapperRef = createRef<HTMLDivElement>();

    return (
        <div className="page-wrapper" ref={wrapperRef}>
            {itemToEdit === null ? (
                <ThemeList setItemToEdit={setItemToEdit} />
            ) : (
                <ThemeDetail
                    container={wrapperRef}
                    theme={itemToEdit}
                    returnToList={() => setItemToEdit(null)}
                />
            )}
        </div>
    );
};

export default Themes;
